// Mirrors Finkit.Tenants.Admin.EmailRecipients contracts.

// Finkit.Needs.Enums.EmailRecipients.EmailRecipientGroup (numeric enum values
// are the wire contract — do not renumber).
export enum EmailRecipientGroup {
  Asa = 1,
  DtfCoh = 2,
  DailyReport = 3,
  Cmh = 4,
}

export interface EmailRecipientDto {
  id: string;
  // Server-rendered display name (e.g. "ASA", "DTF/COH"), not the raw enum.
  group: string;
  email: string;
}

export interface EmailRecipientGroupSettingDto {
  group: EmailRecipientGroup;
  groupName: string;
  isSuppressed: boolean;
}

export interface CreateEmailRecipientDto {
  group: EmailRecipientGroup;
  email: string;
}

export interface UpdateEmailRecipientDto {
  email: string;
}

export interface SetEmailRecipientGroupModeDto {
  group: EmailRecipientGroup;
  isSuppressed: boolean;
}

// EmailRecipientDatatableInputDto : PaginatedInputDto (PagedAndSortedResultRequestDto).
export interface EmailRecipientDatatableInput {
  skipCount: number;
  maxResultCount: number;
  sorting?: string;
  draw?: number;
  search?: string;
  group?: EmailRecipientGroup;
  email?: string;
}

export const MAX_EMAIL_LENGTH = 256;
